module.exports = __webpack_public_path__ + "img/register_mb_02.ae40d347.png";